import { CardContent, MenuItem } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

import React, { useEffect, useState, useRef } from "react";
import {
  Button,
  Card,
  CardHeader,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import InputText from "../../../../components/InputFields/InputText";
import { InternalNotes } from "../../../../components/ContractComponent/Index";
import InvoiceMail from "../InvoiceMail";
import invoice from "../../../../assets/White-sidebar-icon/Invoice.svg";
import GetProducts from "../../../../components/MaterialsAndLabor/GetMaterialsAndLabor";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { Grid } from "@mui/material";
import { Row, Col } from "react-bootstrap";
import { Typography } from "@mui/material";
import BlueButton from "../../../../components/Button/BlueButton";
import WhiteButton from "../../../../components/Button/WhiteButton";
import { LoaderComponent } from "../../../../components/Icon/Index";
import DiscountTable from "../../../../components/DiscountTable/DiscountTable";
import DatePicker from "../../../../components/DatePicker/DatePicker";
import dayjs from "dayjs";
import moment from "moment";
import { handleAuth } from "../../../../components/Login/Auth";
import { useUserTimezoneFormatter } from "../../../../components/UserTimezoneDateFormatter/UserTimezoneDateFormatter";
import showToast from "../../../../components/Toast/Toster";
import FormSectionCard from "../../../../components/FormShell/FormSectionCard";
import {
  INVOICE_PAYMENT_TERM_OPTIONS,
  INVOICE_PAYMENT_DUE_CUSTOM,
} from "../../../../constants/invoicePaymentTerms";
import { formatUSPhone } from "../../../../utils/usFormat";

const AddInvoice = ({
  invoiceData,
  subTotal,
  formik,
  isNumChange,
  loader,
  setIsNumChange,
  handleInvoiceNumberChange,
  setIssueDate,
  setDueDate,
  DueDate,
  handlePaymentDueChange,
  handleCustomDaysChange,
  lineItems,
  handleSelectChange,
  setLineItems,
  menuIsOpen,
  setMenuIsOpen,
  deleteLineItem,
  showCosts,
  setShowCosts,
  addLineItem,
  discountAmount,
  taxAmount,
  Total,
  dropdownOpen,
  toggle,
  mail,
  setMail,
  setIsCollect,
  setShouldOpenEmailAfterSave,
  CompanyUrl,
  loading,
  setLoading,
  handleClick,
  tokenDecode,
  isDonationMode,
  handleTaxesCalculated,
  quickInvoiceData,
  isQuickInvoice,
  invoiceId,
  saveInvoiceForEmail,
  calculatedTaxes,
  submitAttempted,
  setSubmitAttempted,
  touchedLineItems,
  setTouchedLineItems,
  isNySurcharge,
  cardFeeConfig,
  surchargeDisclaimer,
}) => {
  
  const navigate = useNavigate();
  const location = useLocation();
  const [DateDecode, setDateDecode] = useState("MM/DD/YYYY");
  const [dateFormat, setDateFormat] = useState("MM/DD/YYYY");
  const isSubmitting = useRef(false);

// Use timezone-aware date formatter hook
const formatDateWithUserTimezone = useUserTimezoneFormatter();

  // Helper function to format address
  const formatAddress = (location, isQuickInvoice = false, quickInvoiceData = null) => {
    // Helper to check if a value is empty or "not available"
    const isEmptyOrNotAvailable = (value) => {
      if (!value) return true;
      const trimmed = value.trim().toLowerCase();
      return trimmed === "" || 
             trimmed === "address not available" || 
             trimmed === "city not available" || 
             trimmed === "state not available" || 
             trimmed === "zip not available" ||
             trimmed === "not available";
    };

    if (isQuickInvoice && quickInvoiceData) {
      const address = (quickInvoiceData?.customerAddress || "").trim();
      const city = (quickInvoiceData?.customerCity || "").trim();
      const state = (quickInvoiceData?.customerState || "").trim();
      const zip = (quickInvoiceData?.customerZip || "").trim();
      
      if (isEmptyOrNotAvailable(address) && isEmptyOrNotAvailable(city) && isEmptyOrNotAvailable(state) && isEmptyOrNotAvailable(zip)) {
        return "Address not available";
      }
      
      const addressParts = [];
      if (!isEmptyOrNotAvailable(address)) addressParts.push(address);
      if (!isEmptyOrNotAvailable(city)) addressParts.push(city);
      if (!isEmptyOrNotAvailable(state)) addressParts.push(state);
      if (!isEmptyOrNotAvailable(zip)) addressParts.push(zip);
      
      return addressParts.length > 0 ? addressParts.join(", ") : "Address not available";
    }
    
    if (!location) return "Address not available";
    
    const address = (location?.Address || "").trim();
    const city = (location?.City || "").trim();
    const state = (location?.State || "").trim();
    const zip = (location?.Zip || "").trim();
    
    if (isEmptyOrNotAvailable(address) && isEmptyOrNotAvailable(city) && isEmptyOrNotAvailable(state) && isEmptyOrNotAvailable(zip)) {
      return "Address not available";
    }
    
    const addressParts = [];
    if (!isEmptyOrNotAvailable(address)) addressParts.push(address);
    if (!isEmptyOrNotAvailable(city)) addressParts.push(city);
    if (!isEmptyOrNotAvailable(state)) addressParts.push(state);
    if (!isEmptyOrNotAvailable(zip)) addressParts.push(zip);
    
    return addressParts.length > 0 ? addressParts.join(", ") : "Address not available";
  };

  // Set default issue date to current date
  useEffect(() => {
    if (!formik?.values?.IssueDate) {
      const currentDate = formatDateWithUserTimezone(new Date().toISOString(), {
        dateFormat: dateFormat,
        includeSeconds: false
      });
      // The timezone hook returns "-" until its auth call resolves. Writing
      // that placeholder into form state is what trips the server's
      // Joi.date() check ("\"IssueDate\" must be a valid date").
      if (!currentDate || currentDate === "-") return;
      formik?.setFieldValue("IssueDate", currentDate);
      setIssueDate(currentDate);
    }
  }, [dateFormat, formatDateWithUserTimezone]);


 
  useEffect(() => {
    const handleDateFormat = () => {
      if (DateDecode?.Format) {
        try {
          const testDate = moment().format(DateDecode?.Format);
          if (testDate && testDate !== "Invalid date") {
            setDateFormat(DateDecode?.Format);
          } else {
            console.warn(
              "Invalid date format from backend, using default:",
              DateDecode?.Format
            );
            setDateFormat("MM/DD/YYYY");
          }
        } catch (error) {
          console.warn("Error validating date format, using default:", error);
          setDateFormat("MM/DD/YYYY");
        }
      } else {
        setDateFormat("MM/DD/YYYY");
      }
    };
    handleDateFormat();

    // Set default issue date to current date
    if (!formik?.values?.IssueDate) {
      const currentDate = formatDateWithUserTimezone(new Date().toISOString(), {
        dateFormat: dateFormat,
        includeSeconds: false
      });
      // Same guard as the sibling effect: don't seed IssueDate with the
      // formatter's "not-ready" placeholder, or Joi.date() rejects on save.
      if (!currentDate || currentDate === "-") return;
      formik?.setFieldValue("IssueDate", currentDate);
      setIssueDate(currentDate);
    }
  }, [DateDecode, dateFormat]);

  useEffect(() => {
    const fetchDateFormat = async () => {
      try {
        const res = await handleAuth(navigate, location);
        if (res?.themes?.Format) {
          setDateDecode(res?.themes);
        } else {
          setDateDecode({ Format: "MM/DD/YYYY" });
        }
      } catch (error) {
        setDateDecode({ Format: "MM/DD/YYYY" });
      }
    };
    fetchDateFormat();
  }, [navigate, location]);

  const formatDate = (date) => {
    if (!date) return "";
    try {
      return formatDateWithUserTimezone(date, {
        dateFormat: dateFormat,
        includeSeconds: false
      });
    } catch (error) {
      console.error("Error formatting date:", error);
      return formatDateWithUserTimezone(date, {
        dateFormat: "MM/DD/YYYY",
        includeSeconds: false
      });
    }
  };

  return (
    <>
      {loader ? (
        <Grid className="Typography-5 m-2 m-md-3" sx={{ width: "100%", maxWidth: "100%" }}>
          <LoaderComponent
            variant="skeleton"
            skeletonLayout="detail"
            loader={loader}
            height="50"
            width="50"
          />
        </Grid>
      ) : (
        <Grid style={{ overflow: "visible" }}>
          <BlueButton
            isDonationMode={isDonationMode}
            className="customer-details-back-btn"
            aria-label="Go back"
            label={
              <ArrowBackOutlinedIcon sx={{ fontSize: 22, color: "#ffffff" }} />
            }
            onClick={handleClick}
            style={{
              marginRight: "10px",
              width: "50px",
              height: "40px",
              minHeight: "40px",
              marginBottom: "10px",
              padding: "0px",
              borderRadius: "8px",
              marginTop: "10px",
            }}
          />
          <Card
            className="my-2 col-12 border-rgba-blue"
            style={{ borderRadius: "20px" }}
          >
            <CardHeader
              className="invoice-header invoice-header-cardhead"
              style={{
                background: "transparent",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography
                component="span"
                style={{
                  borderRadius: "50%",
                  width: "52px",
                  height: "52px",
                  minWidth: "52px",
                  minHeight: "52px",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: 0,
                }}
                className={`invoiceNameHolder_icon invoice-header-icon-circle bg-blue-color ${
                  isDonationMode ? "bg-donor-color" : "bg-blue-color"
                }`}
              >
                <img
                  src={invoice || "/placeholder.svg"}
                  alt="Invoice Icon"
                  className="invoiceInerImg"
                />
              </Typography>{" "}
              <Grid className="invoice-name invoiceHolder_person invoice-header-title-wrap">
                &nbsp;{" "}
                <span
                  style={{ fontSize: "27px", fontWeight: "700" }}
                  className="invoiceHolderName text-blue-color"
                >
                 {invoiceId ? "Edit Invoice for" : "New Invoice for"}{" "}
                  {isQuickInvoice
                    ? quickInvoiceData?.customerName || "Customer Name"
                    : (() => {
                        const firstName = invoiceData?.customer?.FirstName || invoiceData?.customerData?.FirstName || "FirstName not available";
                        const lastName = invoiceData?.customer?.LastName || invoiceData?.customerData?.LastName || "LastName not available";
                        return `${firstName} ${lastName}`.trim();
                      })()}
                </span>
              </Grid>
            </CardHeader>
            <Grid className="first-invoice text-blue-color invoice-add-shell">
              <Card
                style={{
                  border: "none",
                  overflow: "visible",
                }}
              >
                <CardContent style={{ overflow: "visible" }}>
                  <div
                    className="invoice-first invoiceAllDetails w-100"
                    style={{ borderBottom: "1px solid rgba(6, 49, 100, 0.3)" }}
                  >
                  <Row className="g-3 g-lg-4 pt-2 align-items-start invoice-header-job-row invoice-header-two-col mx-0 w-100 pb-3">
                    <Col
                      xs={12}
                      lg={6}
                      className="mt-3 order-1 invoice-header-col-left invoiceSubject_part ps-0 pe-lg-3"
                    >
                      <InputText
                        value={formik?.values?.Subject}
                        onChange={(e) => {
                          formik.handleChange(e);
                          if (formik.touched.Subject && e.target.value && formik.errors.Subject) {
                            formik.setFieldError("Subject", undefined);
                          }
                        }}
                        onBlur={(e) => {
                          formik.handleBlur(e);
                          formik.setFieldTouched("Subject", true);
                        }}
                        error={
                          (submitAttempted && (!formik?.values?.Subject || formik?.values?.Subject === "" || Boolean(formik?.errors?.Subject))) ||
                          (formik?.touched?.Subject && (!formik?.values?.Subject || formik?.values?.Subject === "" || Boolean(formik?.errors?.Subject)))
                        }
                        helperText={undefined}
                        name="Subject"
                        id="invoice_subject"
                        placeholder="Enter invoice subject or brief description of services..."
                        label="Subject"
                        required
                        type="text"
                        className="text-blue-color w-100 subject-invoice invoiceSubject_input"
                        fieldHeight="44px"
                        fullWidth
                      />
                      <Row
                        className="mt-4 g-3 mx-0 w-100 invoice-detail-address quoteProperty_detail"
                        style={{ color: "rgba(6, 49, 100, 1)" }}
                      >
                        <Col xs={12} md={6} className="text-start ps-0 pe-md-3">
                          <Typography className="titleAdress text-blue-color fw-medium">
                            Billing Address
                          </Typography>
                          <Typography className="subAddress text-blue-color">
                            {formatAddress(
                              invoiceData?.location || invoiceData?.locationData,
                              isQuickInvoice,
                              quickInvoiceData
                            )}
                          </Typography>
                        </Col>
                        <Col xs={12} md={6} className="text-start pe-0 ps-md-0">
                          <Typography className="titleAdress text-blue-color fw-medium">
                            Contact Details
                          </Typography>
                          <Typography className="subAddress text-blue-color">
                            {(() => {
                              const phone = isQuickInvoice
                                ? quickInvoiceData?.customerPhone
                                : invoiceData?.customer?.PhoneNumber;
                              const phoneStr = (phone || "").trim().toLowerCase();
                              const isValidPhone = phone &&
                                phoneStr !== "" &&
                                phoneStr !== "phone not available" &&
                                phoneStr !== "not available";

                              return isValidPhone ? (
                                <>
                                  {formatUSPhone(phone)}
                                  <br />
                                </>
                              ) : null;
                            })()}
                            <a
                              href={`mailto:${
                                isQuickInvoice
                                  ? quickInvoiceData?.customerEmail
                                  : invoiceData?.customer?.EmailAddress
                              }`}
                            >
                              {isQuickInvoice
                                ? quickInvoiceData?.customerEmail ||
                                  "Email not available"
                                : invoiceData?.customer?.EmailAddress ||
                                  "Email not available"}
                            </a>
                          </Typography>
                        </Col>
                      </Row>
                    </Col>
                    <Col
                      xs={12}
                      lg={6}
                      className="mt-3 order-2 invoice-header-col-right second-section-invoice invoiceNumber_detailDate ps-0 pe-0"
                    >
                      <div className="quote-number-aside invoice-number-aside-col mb-3 mb-lg-4">
                        {!isNumChange ? (
                          <>
                            <div className="quote-number-aside__label">
                              Invoice Number
                              <span className="cs-field-label-required" aria-hidden="true">
                                {" "}
                                *
                              </span>
                            </div>
                            <div className="quote-number-aside__panel">
                              <span className="quote-number-aside__value">
                                #
                                {formik?.values?.InvoiceNumber ?? "—"}
                              </span>
                              <button
                                type="button"
                                className="quote-number-aside__change"
                                onClick={() => setIsNumChange(true)}
                              >
                                Change
                              </button>
                            </div>
                          </>
                        ) : (
                          <div className="quote-number-aside__edit">
                            <InputText
                              value={formik?.values?.InvoiceNumber}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (value < 0) {
                                  e.target.value = 0;
                                }
                                formik.handleChange(e);
                                if (formik.touched.InvoiceNumber && value && formik.errors.InvoiceNumber) {
                                  formik.setFieldError("InvoiceNumber", undefined);
                                }
                              }}
                              onBlur={(e) => {
                                formik.handleBlur(e);
                                formik.setFieldTouched("InvoiceNumber", true);
                              }}
                              error={
                                (submitAttempted && (!formik?.values?.InvoiceNumber || formik?.values?.InvoiceNumber <= 0 || Boolean(formik?.errors?.InvoiceNumber))) ||
                                (formik?.touched?.InvoiceNumber && (!formik?.values?.InvoiceNumber || formik?.values?.InvoiceNumber <= 0 || Boolean(formik?.errors?.InvoiceNumber)))
                              }
                              helperText={undefined}
                              name="InvoiceNumber"
                              id="InvoiceNumber"
                              label="Invoice Number"
                              required
                              type="number"
                              className="text-blue-color w-100"
                              fieldHeight="44px"
                              fullWidth
                            />
                            <div className="quote-number-aside__done">
                              <BlueButton
                                onClick={handleInvoiceNumberChange}
                                className="buttons outline-button-blue-color outline selectclientaddquote bg-blue-color"
                                label="Done"
                              />
                            </div>
                          </div>
                        )}
                      </div>

                      <Grid className="form-group invoice-form-group invoice-detail-field-row issuedDate_dueDate_paymentDue issueDateFlex">
                              <label
                                htmlFor="IssueDate"
                                className="text-blue-color invoice-detail-label"
                              >
                                Issued Date
                              </label>
                              <Grid
                                className="d-flex gap-1 invoice-date dueDate_invoice payDueRange2 invoice-detail-field-control"
                                style={{ marginLeft: 0 }}
                              >
                                  <Grid
                                  className="issueDate_select issuedateReponsiveDate"
                                  style={{ width: "100%", maxWidth: "100%" }}
                                >
                                  <DatePicker
                                    name="IssueDate"
                                    label={undefined}
                                    fieldHeight="44px"
                                    placeholder={`Enter date (${dateFormat})`}
                                    value={formik?.values?.IssueDate || null}
                                    onChange={(e) => {
                                      const value = e?.target?.value;
                                      const startDate =
                                        value && value !== null && value !== "" && dayjs(value).isValid()
                                          ? dayjs(value).format(DateDecode?.Format)
                                          : null;

                                      formik.setFieldValue(
                                        "IssueDate",
                                        startDate
                                      );

                                      setIssueDate(startDate);
                                    }}
                                    onBlur={formik?.handleBlur}
                                    format={dateFormat}
                                    className="datPicherInvoice my-1"
                                    error={
                                      formik?.touched?.IssueDate &&
                                      Boolean(formik?.errors?.IssueDate)
                                    }
                                    helperText={
                                      formik?.touched?.IssueDate && formik?.errors?.IssueDate
                                    }
                                    slotProps={{
                                      textField: {
                                        sx: {
                                          "& .MuiOutlinedInput-root": {
                                            width: "100%",
                                            minWidth: "0",
                                            maxWidth: "100%",
                                          },
                                        },
                                      },
                                    }}
                                  />
                                </Grid>
                              </Grid>
                            </Grid>

                      <Grid className="form-group invoice-detail-field-row issuedDate_dueDate_paymentDue issueDateFlex">
                              <label
                                htmlFor="paymentDueSelect"
                                className="text-blue-color invoice-detail-label"
                              >
                                Payment Due
                              </label>
                              <Grid
                                className="mt-0 d-flex gap-2 payDueRange invoice-detail-field-control"
                                style={{ marginLeft: 0, flexWrap: "wrap", alignItems: "center" }}
                              >
                                <div
                                  className="payDueRange invoice-payment-due-select"
                                  style={{
                                    width: "100%",
                                    maxWidth: "100%",
                                    marginLeft: 0,
                                  }}
                                >
                                  <InputText
                                    select
                                    id="paymentDueSelect"
                                    name="PaymentDue"
                                    ariaLabel="Payment due"
                                    label=""
                                    placeholder="Select payment terms"
                                    fieldHeight="44px"
                                    fullWidth
                                    className="text-blue-color w-100"
                                    value={formik?.values?.PaymentDue ?? ""}
                                    onChange={(e) => {
                                      formik?.handleChange(e);
                                      handlePaymentDueChange(e);
                                    }}
                                    onBlur={formik?.handleBlur}
                                    helperText={undefined}
                                    showErrorOnly={true}
                                    error={false}
                                    SelectProps={{
                                      displayEmpty: true,
                                      renderValue: (selected) => {
                                        if (
                                          selected == null ||
                                          selected === ""
                                        ) {
                                          return (
                                            <span
                                              style={{
                                                color: "rgba(0, 0, 0, 0.6)",
                                              }}
                                            >
                                              Select payment terms
                                            </span>
                                          );
                                        }
                                        if (selected === INVOICE_PAYMENT_DUE_CUSTOM) {
                                          return "Custom Days";
                                        }
                                        const opt = INVOICE_PAYMENT_TERM_OPTIONS.find(
                                          (o) => o.value === selected
                                        );
                                        return opt ? opt.label : selected;
                                      },
                                    }}
                                  >
                                    <MenuItem value="" disabled>
                                      Select payment terms
                                    </MenuItem>
                                    {INVOICE_PAYMENT_TERM_OPTIONS.map((o) => (
                                      <MenuItem key={o.value} value={o.value}>
                                        {o.label}
                                      </MenuItem>
                                    ))}
                                    <MenuItem value={INVOICE_PAYMENT_DUE_CUSTOM}>
                                      Custom Days
                                    </MenuItem>
                                  </InputText>
                                </div>
                                {formik?.values?.PaymentDue ===
                                  INVOICE_PAYMENT_DUE_CUSTOM && (
                                  <div
                                    className="invoice-payment-due-custom-days"
                                    style={{
                                      width: "130px",
                                      marginLeft: 0,
                                      flexShrink: 0,
                                    }}
                                  >
                                    <InputText
                                      id="customDays"
                                      name="CustomDays"
                                      type="number"
                                      ariaLabel="Custom days"
                                      label=""
                                      placeholder="Days"
                                      className="text-blue-color w-100"
                                      fieldHeight="44px"
                                      fullWidth
                                      value={formik?.values?.CustomDays || ""}
                                      inputProps={{ min: 1, max: 365 }}
                                      onChange={(e) => {
                                        formik?.handleChange(e);
                                        handleCustomDaysChange(e);
                                      }}
                                      onBlur={formik?.handleBlur}
                                      helperText={undefined}
                                      showErrorOnly={true}
                                      error={false}
                                    />
                                  </div>
                                )}
                              </Grid>
                            </Grid>
                      <Grid className="form-group invoice-form-group invoice-detail-field-row issuedDate_dueDate_paymentDue issueDateFlex">
                              <label
                                htmlFor="DueDate"
                                className="text-blue-color invoice-detail-label"
                              >
                                Due Date
                              </label>
                              <Grid
                                className="d-flex gap-1 invoice-date dueDate_invoice payDueRange2 invoice-detail-field-control"
                                style={{ marginLeft: 0 }}
                              >
                                <Grid
                                  className="issueDate_select issuedateReponsiveDate"
                                  style={{ width: "100%", maxWidth: "100%" }}
                                >
                                  <DatePicker
                                    name="DueDate"
                                    label={undefined}
                                    fieldHeight="44px"
                                    value={DueDate || null}
                                    onChange={(e) => {
                                      const value = e?.target?.value;
                                      const dueDateValue =
                                        value && value !== null && value !== "" && dayjs(value).isValid()
                                          ? dayjs(value).format(DateDecode?.Format)
                                          : null;
                                      setDueDate(dueDateValue);
                                    }}
                                    format={dateFormat}
                                    className="datPicherInvoice my-1"
                                    disabled
                                    placeholder={`Enter date (${dateFormat})`}
                                    slotProps={{
                                      textField: {
                                        sx: {
                                          "& .MuiOutlinedInput-root": {
                                            width: "100%",
                                            minWidth: "0",
                                            maxWidth: "100%",
                                          },
                                        },
                                      },
                                    }}
                                  />
                                </Grid>
                              </Grid>
                            </Grid>
                    </Col>
                  </Row>
                  </div>
                </CardContent>
              </Card>
              <Grid className="p-3">
                <FormSectionCard
                  title="Line Items"
                  className="my-4 cs-form-section--quote-line-items cs-form-section--invoice-line-items"
                  contentClassName="getproduct-mamin"
                >
                  {lineItems.map((item, index) => (
                    <React.Fragment key={index}>
                      <GetProducts
                        item={item}
                        index={index}
                        handleSelectChange={handleSelectChange}
                        lineItems={lineItems}
                        setLineItems={setLineItems}
                        showCosts={showCosts}
                        setShowCosts={setShowCosts}
                        menuIsOpen={menuIsOpen}
                        setMenuIsOpen={setMenuIsOpen}
                        deleteLineItem={deleteLineItem}
                        visitInfo={
                          item.VisitDate
                            ? `(Visit: ${formatDate(item?.VisitDate)})`
                            : ""
                        }
                        submitAttempted={submitAttempted}
                        touchedLineItems={touchedLineItems}
                        setTouchedLineItems={setTouchedLineItems}
                      />
                    </React.Fragment>
                  ))}
                </FormSectionCard>

                  <Grid
                    className="d-flex justify-content-between align-items-center mb-0 pb-0 newlineitem"
                    style={{
                      marginTop: "20px",
                      background: "none",
                      border: "none",
                    }}
                  >
                    <BlueButton
                      className="bg-button-blue-color addnewline mx-0 text-white-color "
                      onClick={addLineItem}
                      isDonationMode={isDonationMode}
                      label="+ New Line Item"
                    />
                  </Grid>
                  <Grid className="d-flex my-4 client-message">
                    <Col
                      className="col-5 order-sm-1 messageinput"
                      xl={5}
                      md={5}
                    >
                      <InputText
                        value={formik?.values?.Message}
                        onChange={formik?.handleChange}
                        onBlur={formik?.handleBlur}
                        name="Message"
                        id="client_message"
                        placeholder="Enter client message"
                        label="Client Message"
                        type="text"
                        className="text-blue-color mx-0 w-100"
                        multiline
                        rows={4}
                        fullWidth
                      />
                      <InputText
                        value={formik?.values?.ContractDisclaimer}
                        onChange={formik?.handleChange}
                        onBlur={formik?.handleBlur}
                        name="ContractDisclaimer"
                        id="ContractDisclaimer"
                        placeholder="Enter contract/disclaimer"
                        label="Contract / Disclaimer"
                        type="text"
                        className="text-blue-color mx-0 w-100 mt-3"
                        multiline
                        rows={4}
                        fullWidth
                        fieldHeight="96px"
                      />
                      {surchargeDisclaimer &&
                        surchargeDisclaimer.trim().length > 0 && (
                          <InputText
                            value={surchargeDisclaimer}
                            name="SurchargeDisclaimer"
                            id="SurchargeDisclaimer"
                            label="Surcharge Disclaimer"
                            type="text"
                            className="text-blue-color mx-0 w-100 mt-3"
                            multiline
                            rows={4}
                            fullWidth
                            fieldHeight="96px"
                            InputProps={{ readOnly: true }}
                          />
                        )}
                    </Col>
                    <Col className="col-6 order-sm-2 totalinput" xl={7} md={7}>
                      <DiscountTable
                        subTotal={subTotal}
                        discountAmount={discountAmount}
                        taxAmount={taxAmount}
                        Total={Total}
                        formik={formik}
                        lineItems={lineItems}
                        onTaxesCalculated={handleTaxesCalculated}
                        tokenDecode={tokenDecode}
                        isNySurcharge={isNySurcharge}
                        cardFeeConfig={cardFeeConfig}
                      />
                    </Col>
                  </Grid>
              </Grid>
              <Grid className="p-3">
                <InternalNotes
                  Total={0}
                  notes={formik?.values?.Notes}
                  setNotes={(value) => formik?.setFieldValue("Notes", value)}
                  attachments={formik?.values?.Attachment}
                  setAttachments={(value) =>
                    formik?.setFieldValue("Attachment", value)
                  }
                />
              </Grid>

              {(() => {
                // Check for form errors (Subject, InvoiceNumber)
                const hasFormErrors = Boolean(
                  formik?.errors?.Subject ||
                  formik?.errors?.InvoiceNumber
                );

                // Check if any form field is touched
                const anyFormFieldTouched = formik?.touched?.Subject || formik?.touched?.InvoiceNumber;

                // Check for line item errors - matches GetProducts component validation logic
                const hasLineItemErrors = lineItems?.some((item, index) => {
                  // Check if Name is missing (this is always required)
                  const nameError = (submitAttempted || touchedLineItems?.[index]?.["Name"]) && (!item?.Name || item?.Name === "");
                  
                  if (nameError) {
                    return true;
                  }

                  // Only check quantity and cost errors if Name exists (user has selected an item)
                  if (!item?.Name || item?.Name === "") {
                    return false; // Don't check other fields if Name is not set
                  }

                  // Determine unit type based on what fields are populated
                  let unitType = null;
                  if (item?.Type === "Materials") {
                    if (item?.Unit && item?.CostPerUnit) unitType = "Unit";
                    else if (item?.Square && item?.CostPerSquare) unitType = "Square";
                    else if (item?.Unit && item?.CostPerSquare) unitType = "Sq. Ft.";
                    else if (item?.CostPerSquare) unitType = "Sq. Ft.";
                  } else if (item?.Type === "Labor") {
                    if (item?.Hourly && item?.CostPerHour) unitType = "Hourly";
                    else if (item?.Fixed && item?.CostPerFixed) unitType = "Fixed";
                  }

                  // If no unit type determined, try to infer from cost fields
                  if (!unitType) {
                    if (item?.CostPerUnit && item?.Unit) unitType = "Unit";
                    else if (item?.CostPerHour && item?.Hourly) unitType = "Hourly";
                    else if (item?.CostPerFixed && item?.Fixed) unitType = "Fixed";
                    else if (item?.CostPerSquare && item?.Unit) unitType = "Sq. Ft.";
                    else if (item?.CostPerSquare) unitType = "Sq. Ft.";
                  }

                  // If we have a unit type, check quantity and cost
                  if (unitType) {
                    const qtyKey = unitType === "Sq. Ft." ? "Unit" : unitType;
                    const qtyValue = item[qtyKey];
                    const qtyDisplay =
                      qtyValue !== undefined && qtyValue !== null
                        ? qtyValue
                        : "1";

                    // Check quantity - only show error if field is touched or submit attempted
                    const qtyTouched = submitAttempted || touchedLineItems?.[index]?.[qtyKey];
                    const qtyNum = Number(qtyDisplay);
                    if (
                      qtyTouched &&
                      (qtyDisplay === "" ||
                        Number.isNaN(qtyNum) ||
                        qtyNum <= 0)
                    ) {
                      return true;
                    }

                    // Check cost based on unit type
                    let costKey, costValue;
                    if (unitType === "Unit") {
                      costKey = "CostPerUnit";
                      costValue = item.CostPerUnit;
                    } else if (unitType === "Hourly") {
                      costKey = "CostPerHour";
                      costValue = item.CostPerHour;
                    } else if (unitType === "Fixed") {
                      costKey = "CostPerFixed";
                      costValue = item.CostPerFixed;
                    } else if (unitType === "Sq. Ft." || unitType === "Square") {
                      costKey = "CostPerSquare";
                      costValue = item.CostPerSquare;
                    }

                    // Only show cost error if field is touched or submit attempted
                    const costTouched = submitAttempted || touchedLineItems?.[index]?.[costKey];
                    if (costTouched && (!costValue || costValue === "" || Number(costValue) <= 0)) {
                      return true;
                    }
                  }

                  return false;
                });

                // Check if any line item field is touched
                const anyLineItemTouched = Object.keys(touchedLineItems || {}).some(index => {
                  const touchedFields = touchedLineItems[index];
                  return touchedFields && Object.values(touchedFields).some(touched => touched === true);
                });

                // Check for overall errors
                const hasErrors = hasFormErrors || hasLineItemErrors;

                // Check if any field is touched (form or line items)
                const anyFieldTouched = anyFormFieldTouched || anyLineItemTouched;

                // shouldShowError - show when there are errors AND (submitted OR any field touched)
                const shouldShowError = hasErrors && (submitAttempted || anyFieldTouched);
                
                return shouldShowError;
              })() && (
                <Grid className="mt-3 mb-2" style={{ width: "100%", paddingLeft: "16px", paddingRight: "16px" }}>
                  <Typography
                    sx={{
                      color: "#dc3545",
                      fontSize: "14px",
                      fontWeight: 500,
                      textAlign: "center",
                    }}
                  >
                    Please correct the red boxes above
                  </Typography>
                </Grid>
              )}

              <Grid
                className="d-flex justify-content-between button-responsive p-4 updateSaveBtnNaviGate"
                style={{ marginTop: "80px", gap: "10px" }}
              >
                <Grid className="footer-buttons">
                  <WhiteButton
                    className="cancelInvoiceBtn"
                    onClick={() => {
                      setSubmitAttempted(false);
                      navigate(-1);
                    }}
                    label="Cancel"
                  />
                </Grid>
                {loading ? (
                  <LoaderComponent variant="skeleton" loading={loading} height="20" width="20" />
                ) : (
                  <Grid className="d-flex gap-2 updateSaveBtnNaviGate">
                    <BlueButton
                      isDonationMode={isDonationMode}
                      disabled={
                        !(
                          formik?.values?.Subject &&
                          lineItems?.length > 0 &&
                          lineItems.every((item) => !!item?.Name)
                        )
                      }
                      onClick={async (e) => {
                        e.preventDefault();
                        if (isSubmitting.current) return;
                        isSubmitting.current = true;
                        try {
                          setSubmitAttempted(true);
                          
                          // Touch all required fields
                          formik.setFieldTouched("Subject", true);
                          formik.setFieldTouched("InvoiceNumber", true);

                          // Check for empty line items and mark them as touched
                          const emptyLineItemIndices = [];
                          lineItems.forEach((item, index) => {
                            if (!item?.Name || item?.Name.trim() === "") {
                              emptyLineItemIndices.push(index);
                              setTouchedLineItems(prev => ({
                                ...prev,
                                [index]: {
                                  ...prev[index],
                                  Name: true
                                }
                              }));
                            }
                          });

                          // If there are empty line items, stop and show error
                          if (emptyLineItemIndices.length > 0) {
                            showToast.error("Please select material or labor for all line items before saving.");
                            isSubmitting.current = false;
                            return;
                          }
                          
                          if (
                            !formik?.values?.Subject ||
                            !formik?.values?.InvoiceNumber ||
                            formik?.values?.InvoiceNumber <= 0 ||
                            lineItems?.length === 0 ||
                            !lineItems.some(item => item?.Name)
                          ) {
                            isSubmitting.current = false;
                            return;
                          }
                          setLoading(true);
                          await formik?.handleSubmit();
                        } finally {
                          setLoading(false);
                          isSubmitting.current = false;
                        }
                      }}
                      label={
                        location.state?.invoiceId
                          ? "Update Invoice"
                          : "Save Invoice"
                      }
                    />
                    {/* Show "Save & Send" dropdown for Workers only */}
                    {(tokenDecode?.Role === "Worker" || tokenDecode?.role === "Worker") && (
                      <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                        <DropdownToggle
                          className={`saveBtnInvoiceChange add-invoice-save-send-dropdown${
                            isDonationMode ? " add-invoice-save-send-dropdown--donor" : ""
                          }`}
                          caret
                          disabled={
                            !(
                              formik?.values?.Subject &&
                              lineItems?.length > 0 &&
                              lineItems.every((item) => !!item?.Name)
                            )
                          }
                        >
                          Save & Send{" "}
                        </DropdownToggle>
                        <DropdownMenu>
                          <DropdownItem
                            className="text-blue-color"
                            onClick={() => {
                              setSubmitAttempted(true);
                              
                              // Touch all required fields
                              formik.setFieldTouched("Subject", true);
                              formik.setFieldTouched("InvoiceNumber", true);

                              // Check for empty line items and mark them as touched
                              const emptyLineItemIndices = [];
                              lineItems.forEach((item, index) => {
                                if (!item?.Name || item?.Name.trim() === "") {
                                  emptyLineItemIndices.push(index);
                                  setTouchedLineItems(prev => ({
                                    ...prev,
                                    [index]: {
                                      ...prev[index],
                                      Name: true
                                    }
                                  }));
                                }
                              });

                              // If there are empty line items, stop and show error
                              if (emptyLineItemIndices.length > 0) {
                                showToast.error("Please select material or labor for all line items before saving.");
                                return;
                              }
                              
                              // Just open the email modal - don't save yet
                              // Invoice will be saved when user clicks "Yes, Send Email" in the modal
                              if (
                                formik?.values?.Subject &&
                                formik?.values?.InvoiceNumber &&
                                formik?.values?.InvoiceNumber > 0 &&
                                lineItems?.length > 0 &&
                                lineItems.every((item) => !!item?.Name)
                              ) {
                                setIsCollect(false);
                                setMail(true);
                              }
                            }}
                            disabled={
                              !(
                                formik?.values?.Subject &&
                                formik?.values?.InvoiceNumber &&
                                formik?.values?.InvoiceNumber > 0 &&
                                lineItems?.length > 0 &&
                                lineItems.every((item) => !!item?.Name)
                              )
                            }
                          >
                            Save and Send Email
                          </DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    )}
                    {/* Show "Save & Send" dropdown for Company users (with Collect Payment option) */}
                    {tokenDecode?.Role === "Company" && (
                      <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                        <DropdownToggle
                          className={`saveBtnInvoiceChange add-invoice-save-send-dropdown${
                            isDonationMode ? " add-invoice-save-send-dropdown--donor" : ""
                          }`}
                          caret
                          disabled={
                            !(
                              formik?.values?.Subject &&
                              lineItems?.length > 0 &&
                              lineItems.every((item) => !!item?.Name)
                            )
                          }
                        >
                          Save & Send{" "}
                        </DropdownToggle>
                        <DropdownMenu>
                          <DropdownItem
                            className="text-blue-color"
                            onClick={() => {
                              setSubmitAttempted(true);
                              
                              // Touch all required fields
                              formik.setFieldTouched("Subject", true);
                              formik.setFieldTouched("InvoiceNumber", true);

                              // Check for empty line items and mark them as touched
                              const emptyLineItemIndices = [];
                              lineItems.forEach((item, index) => {
                                if (!item?.Name || item?.Name.trim() === "") {
                                  emptyLineItemIndices.push(index);
                                  setTouchedLineItems(prev => ({
                                    ...prev,
                                    [index]: {
                                      ...prev[index],
                                      Name: true
                                    }
                                  }));
                                }
                              });

                              // If there are empty line items, stop and show error
                              if (emptyLineItemIndices.length > 0) {
                                showToast.error("Please select material or labor for all line items before saving.");
                                return;
                              }
                              
                              // Just open the email modal - don't save yet
                              // Invoice will be saved when user clicks "Yes, Send Email" in the modal
                              if (
                                formik?.values?.Subject &&
                                formik?.values?.InvoiceNumber &&
                                formik?.values?.InvoiceNumber > 0 &&
                                lineItems?.length > 0 &&
                                lineItems.every((item) => !!item?.Name)
                              ) {
                                setIsCollect(false);
                                setMail(true);
                              }
                            }}
                            disabled={
                              !(
                                formik?.values?.Subject &&
                                formik?.values?.InvoiceNumber &&
                                formik?.values?.InvoiceNumber > 0 &&
                                lineItems?.length > 0 &&
                                lineItems.every((item) => !!item?.Name)
                              )
                            }
                          >
                            Save and Send Email
                          </DropdownItem>
                          <DropdownItem
                            className="text-blue-color"
                            onClick={async () => {
                              if (isSubmitting.current) return;
                              isSubmitting.current = true;
                              try {
                                if (location.state?.invoiceId) {
                                  navigate(`/${CompanyUrl}/invoice-payment`, {
                                    state: {
                                      navigats: [
                                        ...location?.state?.navigats,
                                        "/invoice-payment",
                                      ],
                                      id: invoiceData?.InvoiceId,
                                    },
                                  });
                                } else {
                                  setIsCollect(true);
                                  await formik?.handleSubmit();
                                }
                              } finally {
                                isSubmitting.current = false;
                              }
                            }}
                          >
                            Collect Payment
                          </DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    )}
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Card>
          <InvoiceMail
            modal={mail}
            setModal={setMail}
            customerData={{
              ...(invoiceData?.customer || {}),
              CustomerId: invoiceData?.customer?.CustomerId || invoiceData?.CustomerId || formik?.values?.CustomerId,
              EmailAddress: invoiceData?.customer?.EmailAddress
            }}
            Total={Total}
            invoiceData={invoiceData}
            taxAmount={taxAmount}
            discountAmount={discountAmount}
            subTotal={subTotal}
            formik={formik?.values}
            handleSubmit={formik?.handleSubmit}
            DueDate={DueDate}
            saveInvoiceForEmail={saveInvoiceForEmail}
            calculatedTaxes={calculatedTaxes}
            tokenDecode={tokenDecode}
          />
        </Grid>
      )}
    </>
  );
};

export default AddInvoice;
